// Generated by https://pagedraw.io/pages/12008
import React from 'react';
import Radiobutton from './radiobutton';
import './inputcomponent.css';


export default class Inputcomponent extends React.Component {
  render() {
    return (
      <div className="inputcomponent">
          { ((this.props.type === 'checkbox' ? 'RadioComponent' : 'TextEntryComponent') === "TextEntryComponent") ?
              <div className="inputcomponent-textentrycomponent-2">
                  <div className="inputcomponent-0-0-0">
                      <div className="inputcomponent-description-1">
                          <div className="inputcomponent-0-0-0-0-0">
                              <div className="inputcomponent-description_-2">
                                  { this.props.description }
                              </div>
                          </div>
                      </div>
                      <div className="inputcomponent-textentry-2">
                          <div className="inputcomponent-0-0-0-1-0">
                              <input type="text" placeholder={this.props.placeholder} value={this.props.value} onChange={((e) => this.props.onChange(e, this.props.name))} onKeyDown={((e) => this.props.onKeyDown(e))} className="inputcomponent-textinputofcomponent-1" /> 
                          </div>
                      </div>
                  </div>
              </div>
          : null}
          { ((this.props.type === 'checkbox' ? 'RadioComponent' : 'TextEntryComponent') === "RadioComponent") ?
              <div className="inputcomponent-radiocomponent-7">
                  <div className="inputcomponent-1-0-0">
                      <div className="inputcomponent-description-6">
                          <div className="inputcomponent-1-0-0-0-0">
                              <div className="inputcomponent-description_-9">
                                  { this.props.description }
                              </div>
                          </div>
                      </div>
                      <div className="inputcomponent-background-6">
                          <div className="inputcomponent-1-0-0-1-0">
                              <div className="inputcomponent-etherradiobutton-7">
                                  <Radiobutton state={(this.props.value === 1 ? "selected" : "unselected")} id={(1)} name={this.props.name} onClick={this.props.onClick} /> 
                              </div>
                              <div className="inputcomponent-1-0-0-1-0-1">
                                  <div className="inputcomponent-1-0-0-1-0-1-0">
                                      <div className="inputcomponent-ethertext-0"> ether</div>
                                  </div>
                              </div>
                              <div className="inputcomponent-dairadiobutton-2">
                                  <Radiobutton state={(this.props.value === 0 ? "selected" : "unselected")} id={(0)} name={this.props.name} onClick={this.props.onClick} /> 
                              </div>
                              <div className="inputcomponent-1-0-0-1-0-3">
                                  <div className="inputcomponent-1-0-0-1-0-3-0">
                                      <div className="inputcomponent-daitext-4"> Dai</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          : null}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/pagedraw/inputcomponent.js